/**
 *
 * App
 *
 * This component is the skeleton around the actual pages, and should only
 * contain code that should be seen on all pages. (e.g. navigation bar)
 */

import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Switch, Route, BrowserRouter } from 'react-router-dom';

import { Dashboard } from './modules/Dashboard/Loadable';
import { NotFoundPage } from './components/NotFoundPage/Loadable';
import { useTranslation } from 'react-i18next';
import { CorporateInformationModule } from './modules/CorporateInformationModule/Loadable';

import 'antd/dist/antd.css';
import '../styles/global.less';
import { UserManagementModule } from './modules/UserManagementModule/Loadable';
import { HomePage } from './modules/HomePage/Loadable';
import { LoginModule } from './modules/LoginModule/index';
import { SetPasswordModule } from './modules/SetPassword/Loadable';
import { ForgetPasswordModule } from './modules/ForgetPasswordModule/Loadable';
import { ResetPasswordModule } from './modules/ResetPasswordModule/Loadable';
import { FaqModule } from './modules/FaqModule/Loadable';
import PrivateRoute from './components/PrivateRoute';
import { DigitalAssetManagementModule } from './modules/DigitalAssetManagementModule/Loadable';
import ScrollToTop from './components/ScrollToTop';
import { SettingsModule } from './modules/SettingsModule/Loadable';
import { ProductManagementModule } from './modules/ProductManagementModule/Loadable';
import { IdleTimerProvider } from 'react-idle-timer';
import { auth } from 'utils/auth';
import { useDispatch } from 'react-redux';
import { layoutActions } from './modules/Layout/slice';
import jwtDecode from 'jwt-decode';

export function App() {
  const { i18n } = useTranslation();
  const [show, setShow] = useState(false);

  const dispatch = useDispatch();
  const token = auth.getToken();

  useEffect(() => {
    const credentials = window.sessionStorage.getItem('user_token');
    if (credentials) {
      setShow(true);
    } else {
      setTimeout(() => {
        setShow(true);
      }, 500);
    }

    window.addEventListener('storage', () => {});

    window.addEventListener('storage', event => {
      const credentials = window.sessionStorage.getItem('user_token');
      if (event.key === 'REQUESTING_SHARED_CREDENTIALS' && credentials) {
        window.localStorage.setItem('CREDENTIALS_SHARING', credentials);
        window.localStorage.removeItem('CREDENTIALS_SHARING');
      }
      if (event.key === 'CREDENTIALS_SHARING' && !credentials) {
        if (event.newValue) {
          window.sessionStorage.setItem('user_token', event.newValue);
        }
      }
      if (event.key === 'CREDENTIALS_FLUSH' && credentials) {
        window.sessionStorage.removeItem('CREDENTIALS_TOKEN');
        window.sessionStorage.removeItem('user_token');
        window.location.reload();
      }
    });

    window.localStorage.setItem(
      'REQUESTING_SHARED_CREDENTIALS',
      Date.now().toString(),
    );
    window.localStorage.removeItem('REQUESTING_SHARED_CREDENTIALS');
  }, []);

  if (!show) {
    return null;
  }

  const onIdle = () => {
    // if (auth.getToken()) {
    //   auth.logout();
    //   window.location.replace('/login');
    // }
    console.log('Idle');
  };
  // const onActive = event => {
  //   console.log('active', event);
  // };
  const onAction = event => {
    // console.log('Action', event);
    if (auth.getToken() !== null) {
      // @ts-ignore
      const { exp } = jwtDecode(auth.getToken());
      const expireDate = exp * 1000 - 1000 * (60 * 10);
      if (Date.now() >= expireDate) dispatch(layoutActions.refreshToken());
    }
  };

  return (
    <IdleTimerProvider
      timeout={1000 * 60 * 60 * 24}
      onIdle={onIdle}
      // onActive={onActive}
      onAction={onAction}
      crossTab={true}
      syncTimers={500}
    >
      <BrowserRouter>
        <Helmet
          titleTemplate="%s - OpenPost"
          defaultTitle="OpenPost Production"
          htmlAttributes={{ lang: i18n.language }}
        >
          <meta name="description" content="A React Boilerplate application" />
        </Helmet>
        <ScrollToTop />
        <Switch>
          <Route exact path="/" component={HomePage} />
          <Route exact path="/login" component={LoginModule} />
          <Route exact path="/set-password" component={SetPasswordModule} />
          <Route path="/forgot-password" component={ForgetPasswordModule} />
          <Route exact path="/reset-password" component={ResetPasswordModule} />
          <Route exact path="/faq" component={FaqModule} />
          <PrivateRoute exact path="/dashboard" component={Dashboard} />
          <PrivateRoute
            path="/corporate"
            component={CorporateInformationModule}
          />
          <Route path="/user" component={UserManagementModule} />
          <PrivateRoute
            path="/asset"
            component={DigitalAssetManagementModule}
          />
          <PrivateRoute path="/product" component={ProductManagementModule} />
          <PrivateRoute path="/settings" component={SettingsModule} />
          <Route component={NotFoundPage} />
        </Switch>
      </BrowserRouter>
    </IdleTimerProvider>
  );
}
